module.exports = __webpack_public_path__ + "img/field_goal_right.d9b0fa07.jpg";